import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { FileTypeDataset } from './file-type.dataset';

import { AzureBlobFSLinkedService } from 'app/model/linkedservice/azure-blob-fs.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureBlobFS.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureBlobFS_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureBlobFS_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureBlobFSLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureBlobFSDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
